import React, { useState } from "react";
import  { useHistory } from 'react-router-dom'

function Collapsible(props){
    const[isOpen, setIsOpen] = useState(false);
    let klant = props.klant;
    let i = props.index;
    let colorOne = {backgroundColor: '#c3d8fa'};
    let colorTwo = {backgroundColor: '#95bbf5'};
    let colorThree = {backgroundColor: '#c3d8fa'};
    if(i % 2 == 0) {
        colorOne = {backgroundColor: '#b4cffa'};
        colorTwo = {backgroundColor: '#95bbf5'};
        colorThree = {backgroundColor: '#b4cffa'};
    }

    let abonnementen = klant.abonnementen;
    let history = useHistory();
    return(
        <tbody className="border-2 border-gray-600">
            <tr className ='border-1 border-gray-600' style={colorOne} key={klant.klantId} onClick={()=>setIsOpen(!isOpen)}>
                <td>{klant.naam}</td>
                <td>{klant.relaNr}</td>
                {/* <td>{klant.abonnementen.length}</td> */}
                <td onClick={()=> {history.push("/klant/"+klant.klantId.toString())}}>Details</td>
            </tr>
                {isOpen && abonnementen.length>0&&
                    <tr class='bg-blue-200 border-gray-600 border' style={colorTwo}>
                        <td class="font-semibold">Abonnement naam</td>
                        <td class="font-semibold">Startdatum</td>
                        <td class="font-semibold">Einddatum</td>
                        <td class="font-semibold">Status</td>
                    </tr>}
                    {isOpen && abonnementen.length>0&& abonnementen.map(abonnement =>
                                <tr className ='border-gray-600 border' style={colorThree} key={abonnement.abonnementId} onClick={()=>{history.push({pathname:"/Abonnementtoevoegen",state:{selectedAbonnement:abonnement,klantObject:klant}})}}>
                                    <td>{abonnement.abonnementType.naam}</td>

                                    {abonnement.startdatum ? (
                                        <td>{abonnement.startdatum.toString().split("T")[0]}</td>
                                    ) : (
                                        <td/>
                                    )}
                                    {abonnement.einddatum ? (
                                        <td>{abonnement.einddatum.toString().split("T")[0]}</td>
                                    ) : (
                                        <td/>
                                    )}
                                    <td>{abonnement.status}</td>
                                </tr>)
                    }
            {isOpen&&abonnementen.length<1&&
                <div>
                    -
                </div>
            }
        </tbody>
    )
}
export default Collapsible;